import React, { useState } from "react";
import { Card, Button, Table, Modal, Form, Input, InputNumber, Space, Spin, Tag, message, Select  } from "antd";
import { EditOutlined, DeleteOutlined, PlusOutlined, ArrowLeftOutlined, PrinterOutlined } from "@ant-design/icons";
import { useNavigate, useParams } from "react-router-dom";
import {
  useFetchCategoryQuery,
  useFetchProductsByCategoryQuery,
  useCreateProductMutation,
  useUpdateProductMutation,
  useDeleteProductMutation,
  useAddToPrintQueueMutation,
} from "./label.service";

const { Column } = Table;
const { Option } = Select;

export default function CategoryProducts() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [editingProduct, setEditingProduct] = useState(null);
  const [deleteLoading, setDeleteLoading] = useState("");
  const [quantityModal, setQuantityModal] = useState({ visible: false, product: null });
  const [quantity, setQuantity] = useState(1);

  const { data: categoryData } = useFetchCategoryQuery(id);
  const { data: productsData, isLoading, refetch } = useFetchProductsByCategoryQuery(id);
  const [createProduct, { isLoading: isCreateLoading }] = useCreateProductMutation();
  const [updateProduct, { isLoading: isUpdateLoading }] = useUpdateProductMutation();
  const [deleteProduct] = useDeleteProductMutation();
  const [addToPrintQueue] = useAddToPrintQueueMutation();

  const category = categoryData?.data?.category || {};
  const products = productsData?.data?.products || [];

  const handleAddProduct = () => {
    setEditingProduct(null);
    form.resetFields();
    setIsModalVisible(true);
  };

  const handleEditProduct = (record) => {
    setEditingProduct(record);
    form.setFieldsValue({
      name: record.name,
      description: record.description,
      defaultShelfLife: record.customExpiryRule?.days || 4,
      storageLocation: record.storageLocation,
    });
    setIsModalVisible(true);
  };

  const handleDeleteProduct = async (id) => {
    Modal.confirm({
      title: "Delete Product",
      content: "Are you sure you want to delete this product?",
      onOk: async () => {
        setDeleteLoading(id);
        try {
          await deleteProduct(id).unwrap();
          message.success("Product deleted successfully");
          refetch();
        } catch (error) {
          message.error(error?.data?.message || "Failed to delete product");
        } finally {
          setDeleteLoading("");
        }
      },
    });
  };

  const handleModalOk = async () => {
    try {
      const values = await form.validateFields();
      const productData = {
        name: values.name,
        description: values.description,
        categoryId: id,
        customExpiryRule: {
          enabled: true,
          days: values.defaultShelfLife,
          unit: "Days"
        },
        storageLocation: values.storageLocation,
        isActive: true
      };
      
      if (editingProduct) {
        await updateProduct({ id: editingProduct._id, data: productData }).unwrap();
        message.success("Product updated successfully");
      } else {
        await createProduct(productData).unwrap();
        message.success("Product created successfully");
      }
      setIsModalVisible(false);
      form.resetFields();
      refetch();
    } catch (error) {
      message.error(error?.data?.message || "Operation failed");
    }
  };

  const handleAddToQueue = (product) => {
    setQuantityModal({ visible: true, product });
    setQuantity(1);
  };

  const handleQuantityConfirm = async () => {
    try {
      await addToPrintQueue({
        productId: quantityModal.product._id,
        quantity: quantity,
      }).unwrap();
      message.success(`Added ${quantity} label(s) to print queue`);
      setQuantityModal({ visible: false, product: null });
    } catch (error) {
      message.error(error?.data?.message || "Failed to add to queue");
    }
  };

  const handleViewProduct = (productId) => {
    navigate(`/label/product/${productId}`);
  };

  return (
    <>
      <Card
        title={
          <Space>
            <Button icon={<ArrowLeftOutlined />} onClick={() => navigate("/label/category")} />
            <span style={{ fontSize: "18px", fontWeight: "bold" }}>{category.name} - Products</span>
          </Space>
        }
        extra={
          <Button type="primary" icon={<PlusOutlined />} onClick={handleAddProduct}>
            Add Product
          </Button>
        }
      >
        <Spin spinning={isLoading}>
          <Table dataSource={products} rowKey="_id" pagination={{ pageSize: 10 }}>
            <Column title="PRODUCT" dataIndex="name" />
            <Column title="INGREDIENTS/ALLERGENS" 
              render={(_, record) => {
                const allergens = record.allergens?.map(a => a.name) || [];
                const customAllergens = record.customAllergens?.map(a => a.name) || [];
                const allAllergens = [...allergens, ...customAllergens];
                return allAllergens.length > 0 ? allAllergens.join(", ") : "—";
              }} 
            />
            <Column title="STORAGE OVERRIDE" dataIndex="storageLocation" render={(loc) => loc || "—"} />
            <Column 
              title="STATE" 
              dataIndex="isActive" 
              render={(active) => (
                <Tag color={active ? "green" : "red"}>{active ? "Active" : "Inactive"}</Tag>
              )} 
            />
            <Column
              title="Actions"
              align="center"
              render={(_, record) => (
                <Space>
                  {/* <Button
                    type="primary"
                    size="small"
                    icon={<PrinterOutlined />}
                    onClick={() => handleAddToQueue(record)}
                  >
                    Print
                  </Button> */}

             
                  <Button
                    size="small"
                    onClick={() => handleViewProduct(record._id)}
                  >
                    View
                  </Button>

                           <Button
                                        className="team-page-container-content-tool"
                                        color="green"
                                        variant="solid"
                                        icon={<EditOutlined />}
                                            onClick={() => handleEditProduct(record)}
                                      >
                                        Edit
                                      </Button>
                  {/* <Button
                    icon={<EditOutlined />}
                    size="small"
                    onClick={() => handleEditProduct(record)}
                  />
                  <Button
                    icon={<DeleteOutlined />}
                    size="small"
                    danger
                    loading={deleteLoading === record._id}
                    onClick={() => handleDeleteProduct(record._id)}
                  /> */}

                  
                      <Button
                         className="team-page-container-content-tool"
                                         variant="solid"
                                         color="danger"
                                         size="small"
                                         icon={<DeleteOutlined />}
                                                         loading={deleteLoading === record._id}
                    onClick={() => handleDeleteProduct(record._id)}
                                      >
                                       Delete
                                      </Button>
                </Space>
              )}
            />
          </Table>
        </Spin>
      </Card>

      <Modal
        title={editingProduct ? "Edit Product" : "Add Product"}
        open={isModalVisible}
        onOk={handleModalOk}
        onCancel={() => setIsModalVisible(false)}
        confirmLoading={isCreateLoading || isUpdateLoading}
      >
        <Form form={form} layout="vertical">
          <Form.Item
            name="name"
            label="Product Name"
            rules={[{ required: true, message: "Please enter product name" }]}
          >
            <Input placeholder="e.g., SEA BREAM, COD, HAKE" />
          </Form.Item>
          <Form.Item name="description" label="Description">
            <Input.TextArea rows={2} />
          </Form.Item>
          <Form.Item
            name="defaultShelfLife"
            label="Default Shelf Life (days)"
            rules={[{ required: true, message: "Please enter shelf life" }]}
          >
            <InputNumber min={1} max={365} style={{ width: "100%" }} />
          </Form.Item>
<Form.Item name="storageLocation" label="Storage Location">
  <Select
    placeholder="Select storage location"
    options={[
      { label: "Fridge", value: "Fridge" },
      { label: "Freezer", value: "Freezer" },
      { label: "Ambient", value: "Ambient" },
    ]}
  />
</Form.Item>
        </Form>
      </Modal>

      <Modal
        title="Add to Print Queue"
        open={quantityModal.visible}
        onCancel={() => setQuantityModal({ visible: false, product: null })}
        onOk={handleQuantityConfirm}
        okText="Add to Queue"
      >
        <div>
          <p>Product: <strong>{quantityModal.product?.name}</strong></p>
          <p>Quantity:</p>
          <InputNumber
            min={1}
            max={100}
            value={quantity}
            onChange={(val) => setQuantity(val)}
            style={{ width: "100%" }}
          />
          <div style={{ marginTop: 16, padding: 12, background: "#f5f5f5", borderRadius: 4 }}>
            <strong>Label Preview:</strong>
            <div style={{ marginTop: 8, textAlign: "center" }}>
              <div>{quantityModal.product?.name}</div>
              <div>{new Date().toLocaleDateString()}</div>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
}